const OPTIONS = [
  { value: "complete", label: "Complete" },
  { value: "in_progress", label: "In Progress" },
  { value: "needs_attention", label: "Needs Attention" },
];

export default function StatusToggle({ name, value = "", onChange }) {
  return (
    <div className="status-toggle" role="group" aria-label="Item status">
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`status-chip status-chip--${option.value}${value === option.value ? " is-selected" : ""}`}
          data-tour={`status-${option.value}`}
          onClick={() => onChange({ target: { name, value: option.value } })}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
